import * as p from '@clack/prompts'
import type { SchemaPromptContext } from '@cli-types/next-adapter/commands.js'
import { cancel } from './cancel.js'

export function cancelIfNeeded<T>(context: SchemaPromptContext, value: T | symbol): T {
  if (p.isCancel(value)) {
    cancel(context)
  }
  return value
}
